import { render, staticRenderFns } from "./settingsTableMappingList.vue?vue&type=template&id=3eb33b34&"
import script from "./settingsTableMappingList.vue.ts?vue&type=script&lang=ts&"
export * from "./settingsTableMappingList.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports